import { useCallback } from 'react';
import { useAppDispatch } from 'redux/hooks';
import { fetchAvailableModulesWithoutLoading } from 'api/manageModules/manageModulesThunks';
import { consoleErrorMessage } from 'utils/commonFunctions/CommonFunctions';

class ModulesFetchManager {
  private retryCount = 0;
  private intervalId: NodeJS.Timer | null = null;
  private dispatch: any = null;

  setDispatch(dispatch: any) {
    this.dispatch = dispatch;
  }

  startInterval() {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }

    this.retryCount = 0;
    this.intervalId = setInterval(() => {
      if (this.retryCount >= 30) {
        if (this.intervalId) {
          clearInterval(this.intervalId);
          this.intervalId = null;
        }
        return;
      }

      try {
        if (this.dispatch) {
          this.dispatch(fetchAvailableModulesWithoutLoading());
          this.retryCount += 1;
        }
      } catch (error) {
        consoleErrorMessage(error);
      }
    }, 10000);
  }
}

const modulesFetchManager = new ModulesFetchManager();

const useFetchDataInterval = () => {
  const dispatch = useAppDispatch();

  const startModulesFetchingInterval = useCallback(() => {
    modulesFetchManager.setDispatch(dispatch);
    modulesFetchManager.startInterval();
  }, [dispatch]);

  return { startModulesFetchingInterval };
};

export default useFetchDataInterval;
